// API_ENDPOINT_URL is sourced from REACT_APP_API_ENDPOINT_URL (set per-environment in
// .env.development / .env.production / .env.test) so a production build never ships
// pointing at a developer's machine. The localhost fallback below only applies when
// no env var is set, i.e. local development.
const API_ENDPOINT_URL =
  process.env.REACT_APP_API_ENDPOINT_URL || "https://localhost:44363/api/";

const dev = {
  API_ENDPOINT_URL,
};

const prod = {
  API_ENDPOINT_URL,
};

const test = {
  API_ENDPOINT_URL,
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      return dev;
  }
};

export const env = getEnv();
